export default __webpack_public_path__ + "static/media/reportIssue.03b512a2.png";